import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { ReviewAssignedMenteesProps } from '../../../types';
import { statusesLabel } from '../../../helper';

interface HeaderData {
  startDate: string;
  endDate: string;
  menteeDeadline: string;
  mentorDeadline: string;
  progress: string;
  progressStatus: string;
}

export const exportToExcel = (
  data: ReviewAssignedMenteesProps[],
  headerData: HeaderData,
  fileName: string
) => {
  const exportData = data?.map((item: ReviewAssignedMenteesProps) => ({
    Employee: item?.name,
    Designation: item?.designation,
    Tier: item?.tier,
    'Mentor Name': item.mentorName,
    'No. of Objectives Set': item.noOfObjectives,
    'Mentor Status': statusesLabel[item.mentorStatus as any],
    'Mentee Status': statusesLabel[item.menteeStatus as any],
  }));

  const topHeader = [
    {
      a1: 'Start Date',
      a2: headerData.startDate,
    },
    {
      a1: 'End Date',
      a2: headerData.endDate,
    },
    {
      a1: 'Mentee Deadline',
      a2: headerData.menteeDeadline,
    },
    {
      a1: 'Mentor Deadline',
      a2: headerData.mentorDeadline,
    },
    {
      a1: 'Progress',
      a2: headerData.progress + '% - ' + headerData.progressStatus,
    },
  ];

  const worksheet = XLSX.utils.json_to_sheet([]);

  XLSX.utils.sheet_add_json(worksheet, topHeader, {
    origin: 'A01',
    skipHeader: true,
  });

  XLSX.utils.sheet_add_json(worksheet, exportData, {
    origin: 'A08',
    skipHeader: false,
  });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, `${fileName}.xlsx`);
};
